import Image from "next/image";
import Link from "next/link";
import React, { useEffect } from "react";

import Card from "@/components/ui/card/card";
import { Search_Type } from "@/graphql/types/graphql";
import HomeCard1 from "@/public/home-card-1.webp";
import HomeCard2 from "@/public/home-card-2.webp";
import HomeCard3 from "@/public/home-card-3.webp";
import HomeCard4 from "@/public/home-card-4.webp";
import HomeCard5 from "@/public/home-card-5.webp";
import HomeCard6 from "@/public/home-card-6.webp";
import HomeCard7 from "@/public/home-card-7.webp";
import HomeCard8 from "@/public/home-card-8.webp";
import HomeCardMobile1 from "@/public/home-card-mobile-1.webp";
import HomeCardMobile2 from "@/public/home-card-mobile-2.webp";
import HomeCardMobile3 from "@/public/home-card-mobile-3.webp";
import HomeCardMobile4 from "@/public/home-card-mobile-4.webp";
import HomeCardMobile5 from "@/public/home-card-mobile-5.webp";
import HomeCardMobile6 from "@/public/home-card-mobile-6.webp";
import HomeCardMobile7 from "@/public/home-card-mobile-7.webp";
import HomeCardMobile8 from "@/public/home-card-mobile-8.webp";
import { encodeURL } from "@/utils/index";

const cards = [
  {
    children: HomeCard1,
    mobileChildren: HomeCardMobile1,
    query: "Pastel colored long-sleeve blouses with ruffle details, size Small",
  },
  {
    children: HomeCard2,
    mobileChildren: HomeCardMobile2,
    query:
      "Versatile midi summer dress, sleek with a fitted waist, no patterns",
  },
  {
    children: HomeCard3,
    mobileChildren: HomeCardMobile3,
    query: "Silk dresses with lace details, no cutout or slits",
  },
  {
    children: HomeCard4,
    mobileChildren: HomeCardMobile4,
    query: "Blazer with cinched waist in neutral colors, on sale, under $500",
  },
  {
    children: HomeCard5,
    mobileChildren: HomeCardMobile5,
    query: "What do I wear for a wedding in Jackson Hole in May? Under $500",
  },
  {
    children: HomeCard6,
    mobileChildren: HomeCardMobile6,
    query:
      "What type of jackets are chic and warm for date nights in San Francisco?",
  },
  {
    children: HomeCard7,
    mobileChildren: HomeCardMobile7,
    query:
      "What should I wear to my rehearsal dinner as the bride on the Amalfi Coast?",
  },
  {
    children: HomeCard8,
    mobileChildren: HomeCardMobile8,
    query: "What kind of work dresses are good for a rectangle body type?",
  },
];

interface HomeCardsProps extends React.HTMLAttributes<HTMLButtonElement> {
  showSkeleton?: boolean;
  page: number;
}

const HomeCards: React.FC<HomeCardsProps> = ({
  page,
  showSkeleton = false,
}) => {
  useEffect(() => {}, []);

  return (
    <>
      {/* Desktop Cards */}
      <div className="cards-container web">
        {cards.map((card, index) => {
          const CardChildren = card.children;
          return (
            <Card
              showSkeleton={showSkeleton}
              key={index}
              style={{
                display:
                  index >= page * 4 && index < (page + 1) * 4
                    ? "block"
                    : "none",
              }}
            >
              <Link
                href={`/edits/${encodeURL(card.query)}?type=${
                  Search_Type.Item
                }`}
              >
                <Image
                  src={CardChildren}
                  alt={`home-card-${index}`}
                  priority={index >= 4}
                />
              </Link>
            </Card>
          );
        })}
      </div>

      {/* Mobile Cards */}
      <div className="cards-container mobile">
        {cards.map((card, index) => {
          const MobileCardChildren = card.mobileChildren;
          return (
            <Card
              showSkeleton={showSkeleton}
              key={index}
              style={{
                display:
                  index >= page * 4 && index < (page + 1) * 4
                    ? "block"
                    : "none",
              }}
            >
              <Link
                href={`/edits/${encodeURL(card.query)}?type=${
                  Search_Type.Item
                }`}
              >
                <Image
                  src={MobileCardChildren}
                  alt={`mobile-home-card-${index}`}
                  priority={index >= 4}
                />
              </Link>
            </Card>
          );
        })}
      </div>

      <style jsx>{`
        .cards-container {
          width: 100%;
          max-width: 800px;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-top: 32px;
          justify-content: center;

          &.mobile {
            display: none;
          }

          @media (max-width: 768px) {
            &.web {
              margin-top: 24px;
              display: none;
            }
            &.mobile {
              display: flex;
            }
          }
        }
      `}</style>
    </>
  );
};

export default HomeCards;
